import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["emailInput", "sendBtn", "status", "savePrompt"];

  async send() {
    const email = this.emailInputTarget.value.trim();
    if (!email) return;

    this.sendBtnTarget.disabled = true;
    this.sendBtnTarget.textContent = "Sending...";

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content;
      const response = await fetch(`/discover/email_results`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": token,
        },
        body: `email=${encodeURIComponent(email)}`,
      });

      if (response.ok) {
        this.showStatus("Results sent! Check your inbox.", "success");
        this.emailInputTarget.disabled = true;
        this.sendBtnTarget.classList.add("d-none");
        if (this.hasSavePromptTarget) {
          this.savePromptTarget.classList.remove("d-none");
        }
      } else if (response.status === 429) {
        this.showStatus("Results already sent to your email.", "success");
        this.emailInputTarget.disabled = true;
        this.sendBtnTarget.classList.add("d-none");
      } else if (response.status === 422) {
        this.showStatus("Please enter a valid email address.", "error");
        this.sendBtnTarget.disabled = false;
        this.sendBtnTarget.textContent = "Email me";
      } else {
        this.showStatus("Something went wrong. Please try again.", "error");
        this.sendBtnTarget.disabled = false;
        this.sendBtnTarget.textContent = "Email me";
      }
    } catch {
      this.showStatus("Something went wrong. Please try again.", "error");
      this.sendBtnTarget.disabled = false;
      this.sendBtnTarget.textContent = "Email me";
    }
  }

  showStatus(message, type) {
    this.statusTarget.textContent = message;
    this.statusTarget.classList.remove("d-none", "text-success", "text-danger");
    this.statusTarget.classList.add(
      type === "success" ? "text-success" : "text-danger",
    );
  }
}
